import * as React from 'react';

import AnonymousPartnerLanding from '../components/anonymous_partner_landing/index';

const AnonymousPartnerLandingApp = (props) => (
  <AnonymousPartnerLanding {...props} />
);

export default AnonymousPartnerLandingApp;
